import { FC } from 'react';
import {
  CreateButton,
  Datagrid,
  EditButton,
  List,
  TextField,
  TopToolbar,
} from 'react-admin';
import { TemperatureField } from '../../../../entities/TemperatureField/ui/TemperatureField';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить модель" />
  </TopToolbar>
);

export const ModelList: FC = () => (
  <List title="Список моделей" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Имя" />
      <TextField source="data_type" label="Тип модели" />
      <TextField source="prompt" label="Промпт" />
      <TemperatureField source="temperature" label="Температура" />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
